import {
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CPagination,
  CRow,
  CLabel,
  CInputGroup,
  CInputGroupText,
  CInput,
  CLink,
} from "@coreui/react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { getList } from "../../api/generics";
import { getRoutePath } from "../../routes";
import { SUCCESS } from "../../utils/constants/tags";
import { successAlert, warningAlert } from "../utils/messages";
import InventoryInputBatch from "../../models/inventory-input-batch";
import BatchAmountModal from "./BatchAmountModal";
import { formatDateTime } from "../../utils/dates";
import {
  BATCH_AMOUNTS_RETRIEVE,
  BATCH_AMOUNTS_UPDATE,
} from "../../auth/permissions";
import PermissionRequiredComponent from "../permissions/PermissionRequiredComponent";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import { defaultValueOnUndefined } from "../../utils/fields";
import { calculateSoldPercentage } from "../../utils/input-batches";
const ITEMS_PER_PAGE = 20;

const BatchAmountList = () => {
  const fields = [
    {
      key: "purchaseDate",
      _classes: ["text-center"],
      label: "Fecha de Compra",
    },
    {
      key: "inputMaterialIdentifier",
      _classes: ["text-center"],
      label: "Materia Prima",
    },
    {
      key: "supplierName",
      _classes: ["text-center"],
      label: "Proveedor",
    },
    {
      key: "clothesProduced",
      _classes: ["text-center"],
      label: "Cant. Producida",
    },
    {
      key: "clothesSold",
      _classes: ["text-center"],
      label: "Cant. Vendida",
    },
    {
      key: "soldPercentage",
      _classes: ["text-center"],
      label: "Porcentaje Vendido",
    },
    {
      key: "actions",
      _classes: ["text-center"],
      label: "Acciones",
      filter: false,
    },
  ];

  const [showEditModal, setShowEditModal] = useState(false);

  const [item, setItem] = useState<InventoryInputBatch | undefined>(undefined);
  const [search, setSearch] = useState<string>("");
  const [startDate, setStartDate] = useState<string | moment.Moment>("");
  const [endDate, setEndDate] = useState<string | moment.Moment>("");

  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<InventoryInputBatch[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const history = useHistory();

  const getURLParams = () => {
    let urlParams = new URLSearchParams(history.location.search);
    let page = urlParams.get("page")
      ? parseInt(urlParams.get("page") as string)
      : 1;

    if (page <= 0) {
      page = 1;
    }
    let search = urlParams.get("search") ? urlParams.get("search") : "";
    let startDate = urlParams.get("start_date")
      ? urlParams.get("start_date")
      : "";
    let endDate = urlParams.get("end_date") ? urlParams.get("end_date") : "";
    let map = new Map();
    map.set("search", search);
    map.set("page", page);
    if (startDate !== "") map.set("start_date", startDate);
    if (endDate !== "") map.set("end_date", endDate);
    return map;
  };

  const fetchItems = async () => {
    const urlParams = getURLParams();
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * Number(urlParams.get("page") - 1);
    urlParams.set("input_material_type", "fabric");
    const requetStatus = await getList<InventoryInputBatch>(
      "/inventory_locations/batches/",
      limit,
      offset,
      urlParams
    );
    if (requetStatus.status === SUCCESS) {
      if (requetStatus.data !== undefined) {
        const count = requetStatus.data.count;
        const pages = Math.ceil((count ? count : 0) / ITEMS_PER_PAGE);
        setTotalPages(pages);
        setItems(requetStatus.data.items);
        setCurrentPage(urlParams.get("page"));
      }
    } else {
      const message = requetStatus.detail
        ? requetStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
    setLoading(false);
  };

  const onPageChange = (page: number) => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    let previousParams = getURLParams();
    urlParams.set(
      "search",
      previousParams.get("search") ? previousParams.get("search") : ""
    );
    if (previousParams.get("start_date")) {
      urlParams.set("start_date", previousParams.get("start_date"));
    }
    if (previousParams.get("end_date")) {
      urlParams.set("end_date", previousParams.get("end_date"));
    }
    urlParams.set("page", page.toString());
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const onUpdateClick = (item: InventoryInputBatch) => {
    setItem(item);
    setShowEditModal(true);
  };

  const onEditCancel = () => {
    setItem(undefined);
    setShowEditModal(false);
  };

  const onEditSuccess = () => {
    successAlert("Datos guardados con éxito!");
    setShowEditModal(false);
    setItems([]);
    setLoading(true);
    fetchItems();
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onStartDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setStartDate("");
      return;
    }
    setStartDate(value);
  };

  const onEndDatehange = (value: string | moment.Moment) => {
    const newDate = value as moment.Moment;
    if (newDate === undefined || !moment(value, true).isValid()) {
      setEndDate("");
      return;
    }
    setEndDate(value);
  };

  const onSearch = () => {
    setLoading(true);
    let urlParams = new URLSearchParams(history.location.search);
    if (search !== "") {
      urlParams.set("search", search);
    } else {
      urlParams.delete("search");
    }
    if (moment.isMoment(startDate)) {
      urlParams.set("start_date", startDate.toISOString());
    } else if (startDate !== undefined && startDate !== "") {
      urlParams.set("start_date", startDate);
    } else {
      urlParams.delete("start_date");
    }
    if (moment.isMoment(endDate)) {
      urlParams.set("end_date", endDate.toISOString());
    } else if (endDate !== undefined && endDate !== "") {
      urlParams.set("end_date", endDate);
    } else {
      urlParams.delete("end_date");
    }
    let url = `?${urlParams.toString()}`;
    history.push(url);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  useEffect(() => {
    fetchItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      if (location.pathname !== getRoutePath("batchAmounts")) {
        return;
      }
      fetchItems();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  return (
    <>
      <CRow>
        <CCol lg="12">
          <CCard>
            <CCardHeader className="d-flex flex-row mb-3">
              <div className="p-2 ">
                <h3>Rendimiento Materia Prima</h3>
              </div>
              <div className="p-2 "></div>
            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol>
                  <h5>Filtros</h5>
                </CCol>
              </CRow>
              <CRow>
                <CCol></CCol>
              </CRow>
              <CRow className={"mt-2"}>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Desde:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onStartDatehange}
                    value={startDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
                <CCol md={2}>
                  <CLabel className={"mt-2"}>Hasta:</CLabel>
                </CCol>
                <CCol>
                  <Datetime
                    className="pl-0"
                    onChange={onEndDatehange}
                    value={endDate}
                    locale="es/PY"
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    closeOnSelect={true}
                  ></Datetime>
                </CCol>
              </CRow>
              <CRow>
                <CCol>
                  <CLabel
                    className="visually-hidden"
                    htmlFor="autoSizingInputGroup"
                  ></CLabel>
                  <CInputGroup>
                    <CInputGroupText>
                      <i className="fa fa-search"></i>
                    </CInputGroupText>
                    <CInput
                      type="text"
                      placeholder="Introduzca el término de busqueda"
                      onChange={onSearchChange}
                      value={search}
                      onKeyDown={handleKeyDown}
                    />
                    <CButton
                      type="button"
                      color="primary"
                      variant="outline"
                      onClick={onSearch}
                    >
                      Buscar
                    </CButton>
                  </CInputGroup>
                </CCol>
              </CRow>
              <div>
                <CDataTable
                  noItemsView={<h2 className="text-center">Sin Resultados</h2>}
                  addTableClasses={"table-fixed"}
                  fields={fields}
                  items={items}
                  striped
                  border
                  loading={loading}
                  responsive
                  scopedSlots={{
                    purchaseDate: (item: InventoryInputBatch) => {
                      return (
                        <td className="text-center">
                          {formatDateTime(new Date(item.purchaseDate!))}
                        </td>
                      );
                    },
                    clothesProduced: (item: InventoryInputBatch) => {
                      return (
                        <td className="text-center">
                          {defaultValueOnUndefined("-", item.clothesProduced)}
                        </td>
                      );
                    },
                    clothesSold: (item: InventoryInputBatch) => {
                      const valueToShow = item.clothesProduced
                        ? item.clothesSold
                        : "-";
                      return (
                        <td className="text-center">
                          {defaultValueOnUndefined("0", valueToShow)}
                        </td>
                      );
                    },
                    soldPercentage: (item: InventoryInputBatch) => {
                      return (
                        <td className="text-center">
                          {defaultValueOnUndefined(
                            "-",
                            calculateSoldPercentage(item)
                          )}
                        </td>
                      );
                    },
                    actions: (item: InventoryInputBatch) => {
                      const editButton = (
                        <PermissionRequiredComponent
                          permissionName={BATCH_AMOUNTS_UPDATE}
                        >
                          <CButton
                            className="text-white"
                            color="warning"
                            onClick={() => {
                              onUpdateClick(item);
                            }}
                          >
                            <i className="fa fa-plus"></i>
                          </CButton>
                        </PermissionRequiredComponent>
                      );
                      const detailButton = (
                        <PermissionRequiredComponent
                          permissionName={BATCH_AMOUNTS_RETRIEVE}
                        >
                          <CLink to={`/batch_amounts/${item.id}/logs/`}>
                            <CButton className="text-white" color="primary">
                              <i className="fa fa-eye"></i>
                            </CButton>
                          </CLink>
                        </PermissionRequiredComponent>
                      );

                      return (
                        <td className="text-right">
                          <CButtonGroup>
                            {item.clothesProduced ? editButton : <></>}
                            {detailButton}
                          </CButtonGroup>
                        </td>
                      );
                    },
                  }}
                />
                <div className="d-flex justify-content-center">
                  <CPagination
                    pages={totalPages}
                    activePage={currentPage}
                    onActivePageChange={(i: number) => onPageChange(i)}
                    className={totalPages < 2 ? "d-none" : ""}
                  />
                </div>
              </div>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <BatchAmountModal
        show={showEditModal}
        onCancel={onEditCancel}
        onSuccess={onEditSuccess}
        item={item}
      />
    </>
  );
};

export default BatchAmountList;
